<template>
  <div class="content-popup">
    <vs-row class="content-popup pb-5 mb-5">

      <div class="content-internal px-0 mb-5 pt-3">

        <h2 style="font-size:20px; text-transform: uppercase;">Termos de uso</h2>
      <p>
        {{genderuppercase}} <strong>{{ terms.hashtag }}</strong> é uma iniciativa d{{genderlowercase}}
        <strong>{{ terms.clientName }}</strong> pessoa jurídica
        <span v-if="containClientCity"> com sede na cidade de {{ terms.clientCity }}</span>
        <span v-else-if="containClientAddress"> com sede à {{ terms.clientAddress }},</span>
        inscrita no CNPJ sob o nº {{ terms.clientCNPJ }} (“{{ terms.clientNickname }}”) e da
        <strong>FANBASE NETWORK TECNOLOGIA E SERVIÇOS S.A.</strong>, pessoa jurídica
        com sede na cidade de Campinas- SP, inscrita no CNPJ sob o nº
        41.835.006/0001-66 ("FANBASE"), doravante {{ terms.clientNickname }} e FANBASE em conjunto
        (“PARTES”).
      </p>
        <p>
          {{genderuppercase}} <strong>{{ terms.hashtag }}</strong> oferece ao Usuário um ambiente digital
          que permite preencher um cadastro e responder a diferentes perguntas visando
          estreitar seu relacionamento com as PARTES e seus parceiros comerciais. Deste
          modo, os presentes Termos de Uso ("Termos") visam regular a utilização por
          você (doravante "Usuário") das Páginas {{pronoun}} <strong>{{ terms.hashtag }}.</strong>
        </p>
        <p>
          Estes Termos estão disponíveis para acesso e consulta a qualquer momento pelo
          Usuário, por meio {{pronoun}} endereço
          <a :href="terms.url" target="_blank"
          >{{ terms.url }}</a
          >. Ainda, aplicam-se aos presentes Termos e na utilização das Páginas o quanto
          disposto na Política de Privacidade {{pronoun}} <strong>{{ terms.hashtag }}</strong>,
          disponível em
          <a :href="terms.url" target="_blank"
          >{{ terms.url }}</a
          >.
        </p>
        <p>
          Ainda, estes Termos poderão ser atualizados, a qualquer tempo, mediante aviso
          no site e/ou por e-mail, se o Usuário tiver optado por receber comunicações
          das PARTES.
        </p>
        <h3>1. CONDIÇÕES DE ACESSO E UTILIZAÇÃO DAS PÁGINAS</h3>
        <h4>1.1 Caráter gratuito {{pronoun}} acesso e utilização das Páginas</h4>
        <p>
          O acesso e a utilização das Páginas pelo Usuário têm, como regra, caráter
          gratuito.
        </p>
        <h4>1.2 Registro de Usuário para participação n{{genderlowercase}} {{ terms.hashtag }}</h4>
        <p>
          Conforme estabelecido pelo regulamento {{pronoun}} <strong>{{ terms.hashtag }}</strong>,
          para poder participar da pesquisa a partir do site
          <strong>{{ terms.hashtag }}</strong>, o Usuário deverá inscrever-se utilizando
          seu CPF e Telefone Celular mediante o preenchimento do formulário disponível
          pelo link:
          <a :href="terms.url" target="_blank"
          >{{ terms.url }}</a
          >, por meio do fornecimento de informações autênticas e verdadeiras.
        </p>
        <p>
          Após a realização do cadastro e aceite aos presentes Termos, o Usuário poderá seguir o preenchimento
          e estará habilitado a participar das possíveis premiações que serão disponibilizadas por meio da plataforma,
          que ocorrerão nos termos do regulamento disponibilizado em
          <a :href="terms.url" target="_blank"
          >{{ terms.url }}</a
          >
        </p>
        <p>
          Nas datas determinadas no Regulamento, os ganhadores serão notificados sobre o
          resultado e a forma de receber a premiação, quando houver.
        </p>
        <p>
          Toda informação fornecida pelo Usuário por meio das Páginas deverá ser
          verdadeira. Assim, o Usuário garante a autenticidade de todos os dados que
          informar durante o preenchimento dos respectivos formulários. Desta forma, o
          Usuário poderá exercer o seu direito de correção de dados incompletos,
          inexatos ou desatualizados, para manter toda a informação fornecida ao
          <strong>{{ terms.hashtag }}</strong> permanentemente atualizada, de forma que
          sempre reflita os dados reais do Usuário.
        </p>
        <p>
          Em qualquer circunstância, o Usuário será o único responsável por declarações
          falsas ou inexatas que prestar e que vierem a causar prejuízos às PARTES, a
          terceiros ou a si mesmo, como por exemplo, no caso de cancelamento de
          premiações por ter dados incorretos ou incompletos.
        </p>
        <p>
          Para maiores informações sobre o tratamento dos dados pessoais coletados para
          essa finalidade, consulte a Política de Privacidade {{pronoun}} {{ terms.hashtag }},
          disponível em
          <a :href="terms.url" target="_blank"
          >{{ terms.url }}</a
          >
          .
        </p>
        <h4>1.3 Obrigação de utilizar as Páginas corretamente</h4>
        <p>
          Ao utilizar as Páginas {{pronoun}} <strong>{{ terms.hashtag }}</strong>, o Usuário se
          compromete a respeitar a legislação brasileira vigente, bem como todo o quanto
          disposto nos presentes Termos, não devendo produzir, disponibilizar, divulgar
          ou transmitir qualquer conteúdo que:
        </p>
        <p>
          <strong>a)</strong> Seja contrário a qualquer norma da legislação brasileira,
          bem como à moral e aos bons costumes geralmente aceitos;
        </p>
        <p>
          <strong>b)</strong> Incentive a discriminação, o ódio ou a violência contra
          pessoas ou grupos em razão de orientação sexual, gênero, raça, religião,
          deficiência, nacionalidade ou por qualquer outro motivo;
        </p>
        <p>
          <strong>c)</strong> Incorporem, ponham à disposição ou permitam acessar
          produtos, elementos, mensagens e/ou serviços ilegais, violentos,
          pornográficos, degradantes ou, em geral, contrários à lei, à moral e aos bons
          costumes geralmente aceitos ou à ordem pública;
        </p>
        <p>
          <strong>d)</strong> Sejam falsos, ambíguos, inexatos, exagerados ou
          extemporâneos, de forma que possam induzir a erro sobre seu objeto ou sobre as
          intenções ou propósitos {{pronoun}} comunicante;
        </p>
        <p>
          <strong>e)</strong> Sejam protegidos por quaisquer direitos de propriedade
          intelectual ou industrial pertencentes a terceiros, sem que o Usuário tenha
          obtido previamente dos seus titulares a autorização necessária para levar a
          cabo o uso que efetuar ou pretender efetuar;
        </p>
        <p>
          <strong>f)</strong> Incorporem vírus ou outros elementos físicos ou
          eletrônicos que possam causar dano ou impedir o normal funcionamento da rede,
          do sistema ou de equipamentos informáticos ("hardware" e "software") de
          terceiros, ou que possam causar dano aos documentos eletrônicos e arquivos
          armazenados nestes equipamentos informáticos; ou,
        </p>
        <p>
          <strong>g)</strong> Provoquem, por suas características (tais como forma,
          extensão etc.) dificuldades no normal funcionamento do Serviço.
        </p>
        <p>
          Em qualquer circunstância, o Usuário é o único responsável pelo uso que fizer
          das Páginas da {{ terms.hashtag }}, bem como por qualquer conteúdo por ele
          inserido.
        </p>
        <h4>1.5 Utilização Correta do Conteúdo e Propriedade Intelectual</h4>
        <p>
          O Usuário se compromete a utilizar as Páginas e o seu conteúdo, ou seja, os
          textos, gráficos, ícones, links, as fotografias, imagens, tecnologia, e demais
          conteúdos audiovisuais ou sonoros, softwares, desenhos gráficos e códigos
          fonte (em conjunto, "Conteúdo(s)"), de acordo com todo o ordenamento jurídico,
          com a moral e os bons costumes geralmente aceitos, com os presentes Termos e
          com as Condições Particulares de cada Página.
        </p>
        <p>
          Todas as marcas, os nomes comerciais ou logotipos de qualquer espécie
          disponibilizados nas Páginas são de propriedade das PARTES, sem que a
          utilização das Páginas possa ser entendida como autorização para que o Usuário
          possa citar tais marcas, nomes comerciais e/ou logotipos.
        </p>
        <p>
          Todo o Conteúdo é de propriedade exclusiva das PARTES, ou de terceiros que
          autorizaram sua utilização nas Páginas, e está protegido por leis e tratados
          internacionais, sendo vedada sua cópia, reprodução, ou qualquer outro tipo de
          utilização, ficando os infratores sujeitos às sanções civis e criminais
          correspondentes, nos termos das Leis 9.610/98, 9.609/98 e 9.279/96.
        </p>
        <p>
          O Usuário deverá se abster de obter, ou de tentar obter, os Conteúdos por
          meios distintos daqueles que, em cada caso, tenham sido colocados à disposição
          para tais propósitos.
        </p>
        <h4>1.6 Política Anti-Spamming</h4>
        <p>Por meio deste documento as PARTES se obrigam a abster-se de:</p>
        <p>
          <strong>a)</strong> obter dados com finalidade publicitária e remeter
          publicidade de qualquer classe com finalidade de venda ou outras de natureza
          comercial sem a prévia solicitação e consentimento;
        </p>
        <p>
          <strong>b)</strong> remeter a um grupo de pessoas quaisquer mensagens não
          solicitadas nem consentidas previamente;
        </p>
        <p>
          <strong>c)</strong> enviar cadeias de mensagens eletrônicas não solicitadas
          nem previamente consentidas;
        </p>
        <p>
          <strong>d)</strong> utilizar listas de distribuição a que se pode ter acesso
          através das Páginas para a realização das atividades descritas nos itens
          acima; e
        </p>
        <p>
          <strong>e)</strong> colocar à disposição de terceiros, com qualquer
          finalidade, dados captados a partir de listas de distribuição.
        </p>
        <p>
          O Usuário ou terceiros prejudicados pela recepção de mensagens não
          solicitados, relacionadas às Páginas e dirigidas a pluralidade de pessoas
          poderão efetuar sua reclamação comunicando as PARTES por meio do site
          <a :href="terms.url" target="_blank"
          >{{ terms.url }}</a
          >
        </p>

        <h4>
          1.7 Introdução de "hiperlinks" que permitam o acesso às Páginas do
          {{ terms.hashtag }}
        </h4>
        <p>
          O Usuário que se propuser a estabelecer hiperlink entre sua página web e as
          Páginas {{pronoun}} {{ terms.hashtag }} ("Hiperlink") deverá cumprir as seguintes
          condições:
        </p>
        <p>
          <strong>a)</strong> o "Hiperlink" permitirá única e exclusivamente o acesso à
          homepage ou à página de início das Páginas, mas não poderá reproduzi-la de
          qualquer forma;
        </p>
        <p>
          <strong>b)</strong> não realizar manifestações ou indicações falsas, inexatas
          ou incorretas sobre as PARTES, seus administradores, empregados ou Páginas;
        </p>
        <p>
          <strong>c)</strong> não declarar nem fazer entender que as PARTES teriam
          autorizado o "Hiperlink" ou que teria supervisionado ou assumido, sob qualquer
          forma, responsabilidade sobre os serviços oferecidos ou colocados à disposição
          na página web em que for estabelecido o "Hiperlink";
        </p>
        <p>
          <strong>d)</strong> com exceção dos sinais que formarem parte do "Hiperlink",
          a página web em que se estabelecer o "Hiperlink" não conterá nenhuma marca,
          nome comercial, logotipo, slogan, look and feel ou quaisquer outros sinais
          pertencentes às PARTES;
        </p>
        <p>
          <strong>e)</strong> a página web em que estabelecer o "Hiperlink" não deverá
          conter informações ou conteúdos ilícitos, contrários à moral, aos bons
          costumes ou à ordem pública, bem como não conterá conteúdos contrários aos
          direitos de terceiros.
        </p>
        <p>
          A fixação de um "Hiperlink" não implica, em qualquer hipótese, a existência de
          relações entre as PARTES e o proprietário da página web que o contiver, nem a
          aceitação ou aprovação das PARTES acerca de seus conteúdos ou serviços.
        </p>
        <h3>2. DURAÇÃO E FINALIZAÇÃO</h3>
        <p>
          O acesso às Páginas {{pronoun}} {{ terms.hashtag }} é concedido ao Usuário por prazo
          indeterminado. As PARTES, no entanto, estão facultadas a dar por terminado,
          suspender ou interromper unilateralmente, a qualquer momento e sem necessidade
          de prévio aviso, o acesso às Páginas, sem que qualquer indenização seja devida
          ao Usuário.
        </p>
        <p>
          As PARTES, ainda, se reservam o direito de recusar ou retirar o acesso às
          Páginas, a qualquer momento e sem necessidade de prévio aviso, por iniciativa
          própria ou por exigência de um terceiro, àqueles Usuários que descumprirem
          estes Termos.
        </p>
        <h3>3. EXCLUSÃO DE GARANTIAS E DE RESPONSABILIDADE</h3>
        <p>
          Em decorrência de questões técnicas e operacionais, as PARTES não podem
          garantir a disponibilidade, infalibilidade e continuidade do funcionamento das
          Páginas, nem garantem a utilidade das Páginas para a realização de qualquer
          atividade em concreto. Desse modo, as PARTES não serão, em hipótese alguma,
          responsáveis por quaisquer danos decorrentes da interrupção do acesso às
          Páginas, ou por falhas de funcionamento delas, nem se responsabilizam pela
          defraudação da utilidade que os Usuários possam ter atribuídos Páginas, pela
          falibilidade das mesmas, nem por qualquer dificuldade de acesso.
        </p>
        <p>
          as PARTES utilizam as melhores práticas recomendadas de mercado para manter
          seguros todos os dados inseridos pelo Usuário nas Páginas, no entanto não
          garante que terceiros não autorizados não farão uso de meios ilícitos para
          obter indevidamente tais informações. Assim, as PARTES se eximem de
          responsabilidade pelos danos e prejuízos de toda natureza que possam decorrer
          do conhecimento que terceiros não autorizados possam ter de quaisquer das
          informações repassadas, em decorrência de falha exclusivamente atribuível aos
          Usuários ou a terceiros que fujam a qualquer controle razoável das PARTES.
        </p>
        <p>
          As PARTES não garantem a ausência de vírus nas Páginas, bem como de outros
          elementos nocivos que possam produzir alterações nos sistemas informáticos dos
          Usuários (software e hardware) ou nos documentos eletrônicos armazenados no
          sistema informático, eximindo-se de qualquer responsabilidade pelos danos e
          prejuízos que possam decorrer de quaisquer elementos nocivos.
        </p>
        <p>
          As PARTES não verificam ou controlam o uso que o Usuário faz das páginas.
          Dessa forma, se eximem de qualquer responsabilidade pelos danos e prejuízos de
          toda natureza que possam decorrer da utilização das Páginas ou que possam ser
          devidos à falta de veracidade, vigência, exaustividade e/ou autenticidade do
          conteúdo lá disponibilizado, bem como da informação que os Usuários
          proporcionam a outros Usuários sobre si mesmos e, em particular, ainda que não
          de forma exclusiva, pelos danos e prejuízos de toda a natureza que possam ser
          devidas à suplantação da personalidade efetuada por um Usuário em qualquer
          classe de comunicação realizada por meio das Páginas.
        </p>
        <h3>4. PROCEDIMENTO EM CASO DE REALIZAÇÃO DE ATIVIDADES DE CARÁTER ILÍCITO</h3>
        <p>
          Na hipótese de um Usuário ou um terceiro considerar que existem informações,
          fatos ou circunstâncias que constituem atividade ilícita, nas Páginas das
          PARTES, especialmente em caso de violação de direitos de propriedade
          intelectual ou outros direitos, deverá enviar comunicação às PARTES contendo
          os seguintes dados:
        </p>
        <p>
          <strong>a)</strong> dados pessoais: nome, endereço, número de telefone e
          endereço de correio eletrônico do reclamante;
        </p>
        <p>
          <strong>b)</strong> especificação da suposta atividade ilícita ocorrida nas
          Páginas e, em particular, quando se tratar de suposta violação de direitos
          autorais, indicação precisa e completa dos conteúdos protegidos e supostamente
          infringidos;
        </p>
        <p>
          <strong>c)</strong> fatos ou circunstâncias que revelam o caráter ilícito de
          tal atividade; e
        </p>
        <p>
          <strong>d)</strong> se o caso, declaração expressa e clara de que a utilização
          dos conteúdos foi realizada sem o consentimento do titular dos direitos de
          propriedade intelectual supostamente infringidos.
        </p>
        <p>
          Sempre de acordo com a legislação em vigor, a partir da ciência, as PARTES
          poderão excluir conteúdo acusado como ilícito, assim como fornecer informações
          às autoridades competentes, mediante o competente requerimento, com a
          finalidade de viabilizar a apuração de condutas ilegais.
        </p>
        <h3>5. DISPOSIÇÕES GERAIS</h3>
        <p>
          Se qualquer parte destes Termos for considerada inválida ou inexequível, tal
          trecho deve ser interpretado de forma consistente com a lei aplicável, para
          refletir, na medida do possível, a intenção original das partes, e as demais
          disposições permanecerão em pleno vigor e efeito.
        </p>
        <p>
          A falha das PARTES em exigir quaisquer direitos ou disposições dos presentes
          Termos não constituirá renúncia, podendo exercer regularmente o seu direito,
          dentro dos prazos legais.
        </p>
        <h3>6. NOTIFICAÇÕES</h3>
        <p>
          Todas as notificações e comunicações (doravante, as "Notificações") por parte
          do Usuário às PARTES deverão ser feitas através do canal “Fale Conosco” do
          site
          <a :href="terms.url" target="_blank"
          >{{ terms.url }}</a
          >.
        </p>
        <p>
          Todas as notificações e comunicações (doravante, as "Notificações") por parte
          das PARTES ao Usuário serão consideradas eficazes, para todos os efeitos,
          quando se realizarem em uma das seguintes formas:
        </p>
        <p>
          <strong>a)</strong> envio de carta ao domicílio do Usuário quando este tiver
          fornecido um endereço válido às PARTES.
        </p>
        <p>
          <strong>b)</strong> envio de mensagem por correio eletrônico a qualquer dos
          endereços fornecidos pelo Usuário; e
        </p>
        <p>
          <strong>c)</strong> comunicação telefônica ao número fornecido pelo Usuário,
          como por SMS e/ou por WhatsApp;
        </p>
        <p>
          Neste sentido, todas as Notificações que as PARTES realizarem serão
          consideradas válidas quando efetuadas empregando os dados e através dos meios
          anteriormente destacados. Para estes efeitos, o Usuário declara que todos os
          dados fornecidos são válidos e corretos, comprometendo-se a comunicar as
          PARTES todas as mudanças relativas aos dados de notificação.
        </p>
        <hr style="margin: 50px 0px 100px 0px; border-top: 2px solid var(--second-color);">

        <h2 style="font-size:20px; text-transform: uppercase;">POLÍTICA DE PRIVACIDADE</h2>
      <p>
        {{genderuppercase}} <strong>{{ terms.hashtag }}</strong> é uma iniciativa da
        <strong>{{ terms.clientName }}</strong> pessoa jurídica
        <span v-if="containClientCity"> com sede na cidade de {{ terms.clientCity }}</span>
        <span v-else-if="containClientAddress"> com sede à {{ terms.clientAddress }},</span>
        inscrita no CNPJ sob o nº {{ terms.clientCNPJ }} (“{{ terms.clientNickname }}”) e da
        <strong>FANBASE NETWORK TECNOLOGIA E SERVIÇOS S.A.</strong>, pessoa jurídica
        com sede na cidade de Campinas- SP, inscrita no CNPJ sob o nº
        41.835.006/0001-66 ("FANBASE"), doravante {{ terms.clientNickname }} e FANBASE em conjunto
        (“PARTES”).
      </p>
        <p>
          As PARTES consideram relevantes os registros eletrônicos e dados pessoais
          deixados por você (“Usuário”) na utilização do site
          <strong>{{ terms.hashtag }}</strong>, disponível por meio do link:
          <a :href="terms.url" target="_blank"
          >{{ terms.url }}</a
          >
          (“Site”), servindo a presente Política de Privacidade ("Política") para
          regular, de forma simples, transparente e objetiva, quais dados e informações
          serão obtidos, assim como quando os mesmos poderão ser utilizados pelas
          PARTES.
        </p>
        <p>
          <strong>Agente de tratamento:</strong> Fanbase Network Tecnologia e Serviços
          S.A., pessoa jurídica com sede na cidade Campinas, inscrita no CNPJ sob o nº
          CNPJ sob o nº 41.835.006/0001-66 ("Fanbase")
        </p>
        <p><strong>Papel no tratamento:</strong> Operadora</p>
        <p>
          <strong>Natureza dos dados tratados:</strong> Dados pessoais fornecidos pelo
          usuário e/ou coletados automaticamente.
        </p>
        <p>
          <strong>Finalidade da utilização dos dados:</strong> Utilizar dados pessoais
          para fins de viabilizar a participação nas campanhas e projetos de
          relacionamento das <strong>PARTES</strong>, e para eventual contato a ser
          estabelecido com os Usuários durante a participação na pesquisa.
        </p>
        <p><strong>Base legal:</strong> Consentimento do titular.</p>
        <p>
          <strong>Compartilhamento:</strong> Operadores e fornecedores de serviços
          essenciais para a execução das campanhas e programas de relacionamento das
          PARTES.
        </p>
        <p>
          <strong>Proteção de Dados:</strong> Medidas de segurança, técnicas e
          administrativas adequadas.
        </p>
        <p>
          <strong>Seus direitos: </strong> Confirmação da existência de tratamento,
          acesso, correção, etc.
        </p>
        <p>
          Esta Política poderá ser atualizada, a qualquer tempo, pelas
          <strong>PARTES</strong>, mediante aviso no site e/ou por e-mail, se o Usuário
          tiver optado por receber comunicações das <strong>PARTES</strong>.
        </p>
        <h3>I. QUAIS DADOS UTILIZAMOS</h3>
        <p>
          As PARTES poderão coletar as informações inseridas ativamente pelo Usuário no
          momento do cadastro e pesquisa e, ainda, informações coletadas automaticamente
          quando da utilização do Site <strong>{{ terms.hashtag }}</strong> e da rede,
          como, por exemplo, identificação do estabelecimento comercial utilizado, IP
          com data e hora da conexão, entre outras.
        </p>
        <p>
          Há, assim, o tratamento de dois tipos de dados pessoais: (i) aqueles
          fornecidos pelo próprio Usuário; e (ii) aqueles coletados automaticamente.
        </p>
        <p>
          (i) Informações fornecidas pelo Usuário: A <strong>FANBASE</strong> coleta
          todas as informações inseridas ativamente pelo Usuário no Site
          <strong>{{ terms.hashtag }}</strong>, quando do preenchimento pelo Usuário do
          cadastro para possibilitar a participação nas campanhas das
          <strong>PARTES</strong>, nos termos de uso disponível em
          <a :href="terms.url" target="_blank"
          >{{ terms.url }}</a
          >. As PARTES farão uso dessas informações para se comunicar com o Usuário
          durante a sua participação na(s) campanha(s) e programas de relacionamento.
        </p>
        <p>
          (ii) Dados coletados automaticamente: A <strong>FANBASE</strong> também coleta
          uma série de informações de modo automático, tais como: características do
          dispositivo de acesso, {{pronoun}} navegador, IP (com data e hora), origem do IP,
          informações sobre cliques, páginas acessadas, as páginas seguintes acessadas
          após a saída do Site, ou qualquer termo de procura digitado nos sites ou em
          referência a estes, dentre outros. Para tal coleta, a
          <strong>FANBASE</strong> fará uso de algumas tecnologias padrões, como
          cookies, pixel tags, beacons, local shared objects, e outras tecnologias que
          são utilizadas com o propósito de melhorar a experiência de navegação do
          Usuário no Site, de acordo com seus hábitos e suas preferências.
        </p>
        <p>
          É possível desabilitar, por meio das configurações de seu navegador de
          internet, a coleta automática de informações por meio de algumas tecnologias,
          como cookies e caches, bem como em nosso próprio website, especificamente
          quanto aos cookies. No entanto, o Usuário deve estar ciente de que, se
          desabilitadas estas tecnologias, alguns recursos oferecidos pelo site, que
          dependem do tratamento dos referidos dados, poderão não funcionar
          corretamente.
        </p>
        <p>
          As informações coletadas poderão ser compartilhadas pelas PARTES com: (i)
          demais empresas parceiras, quando forem necessárias para a adequada prestação
          dos serviços objeto de suas atividades; (ii) para proteção dos interesses das
          PARTES em qualquer tipo de conflito; (iii) mediante decisão judicial ou
          requisição de autoridade competente.
        </p>
        <p>
          Ainda, esclarecemos que suas informações também poderão ser compartilhadas com
          empresas provedoras de infraestrutura tecnológica e operacional necessária
          para as atividades da <strong>FANBASE</strong>, como provedores de serviço de
          armazenamento de informações.
        </p>
        <p>
          O Usuário poderá acessar, atualizar e adicionar seus dados, bem como poderá
          solicitar a exclusão dos seus dados coletados pelas PARTES, ao acessar o site
          <a :href="terms.url" target="_blank"
          >{{ terms.url }}</a
          >
          e entrar com os dados do seu CPF para editar suas respostas previamente
          inseridas ou solicitar a exclusão através do e-mail
          <a href="mailto:excluir@fanbase.com.br">excluir@fanbase.com.br</a>. Iremos nos
          esforçar para respondê-lo no menor tempo possível, respeitando-se os prazos de
          guarda estabelecidos pela legislação.
        </p>
        <h3>II. COMO UTILIZAMOS OS DADOS</h3>
        <p>
          As informações coletadas pelas PARTES têm como finalidade possibilitar a
          participação dos Usuários nas campanhas do programa
          <strong>{{ terms.hashtag }}</strong> e programas de relacionamento das PARTES.
        </p>
        <p>
          As informações coletadas poderão, ainda, ser utilizadas para fins
          publicitários, como para o envio de informações de marcas, produtos, promoções
          e descontos das PARTES ou seus parceiros, bem como a divulgação de eventos e
          de programas de fidelidade, ou para a realização de pesquisa de satisfação,
          mediante o consentimento do Usuário para tal finalidade.
        </p>
        <p>
          Caso não deseje mais receber informativos institucionais do
          <strong>{{ terms.hashtag }}</strong>, a qualquer momento o Usuário pode contatar
          as PARTES por meio do formulário disponível em
          <a :href="terms.url" target="_blank"
          >{{ terms.url }}</a
          >
        </p>
        <p>
          Base Legal: Nestes casos, o tratamento de dados é autorizado pelo inciso I do
          artigo 7º da Lei nº 13.709/2018, a Lei Geral de Proteção de Dados (“Lei Geral
          de Proteção de Dados – LGPD”).
        </p>
        <h3>III. COMO UTILIZAMOS OS COOKIES</h3>
        <p>
          Cookies são arquivos ou informações que podem ser armazenadas em seus
          dispositivos, quando você visita o Site <strong>{{ terms.hashtag }}</strong>.
          Geralmente, um cookie contém o nome do site que o originou, seu tempo de vida
          e um valor, que é gerado aleatoriamente.
        </p>
        <p>
          Utilizamos cookies para facilitar o uso e melhor adaptar o Site aos seus
          interesses e necessidades, bem como para compilarmos informações sobre a
          utilização de nossos sites e serviços, auxiliando a melhorar suas estruturas e
          seus conteúdos. Os cookies também podem ser utilizados para acelerar suas
          atividades e experiências futuras no Site.
        </p>
        <h4>TIPOS DE COOKIES</h4>
        <p>
          Necessários: Esses cookies são essenciais para que o Site carregue
          corretamente e permitem que você navegue em nossos sites e faça uso de todas
          as funcionalidades.
        </p>
        <p>
          Desempenho: Esses cookies nos ajudam a entender como os visitantes interagem
          com o Site, fornecendo informações sobre as áreas visitadas, o tempo de visita
          ao site e quaisquer problemas encontrados, como mensagens de erro.
        </p>
        <p>
          Funcionais: Esses cookies permitem que o Site se lembre de suas escolhas, para
          proporcionar uma experiência mais personalizada. Também, possibilitam que os
          Usuários assistam a vídeos e utilizem ferramentas sociais, campos para
          comentários, fóruns, entre outros.
        </p>
        <p>
          Marketing: Esses cookies são utilizados para fornecer mais conteúdo relevante
          e do interesse dos Usuários. Podem ser utilizados para apresentar publicidade
          mais direcionada ou limitar o número que esta é veiculada, no Site. Também,
          permitem a medição da eficácia de uma campanha publicitária das
          <strong>PARTES</strong>.
        </p>
        <p>
          Após o Usuário consentir para a utilização de cookies, quando do uso do Site
          <strong>{{ terms.hashtag }}</strong>, a FANBASE armazenará um cookie em seu
          dispositivo para lembrar disso na próxima sessão.
        </p>
        <p>
          A qualquer momento, o Usuário poderá revogar seu consentimento quanto aos
          cookies, pelo que deverá apagar os cookies do Site do
          <strong>{{ terms.hashtag }}</strong> utilizando as configurações de seu
          navegador de preferência. Para mais informações sobre como proceder em relação
          à gestão dos cookies nos navegadores:
        </p>
        <p>
          Internet Explorer: <br/>
          <a
              href="https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies"
              target="_blank"
          >https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies
          </a>
        </p>
        <p>
          Mozilla Firefox: <br/>
          <a
              href="https://support.mozilla.org/pt-BR/kb/ative-e-desative-os-cookies-que-os-sites-usam"
              target="_blank"
          >https://support.mozilla.org/pt-BR/kb/ative-e-desative-os-cookies-que-os-sites-usam
          </a>
        </p>
        <p>
          Google Chrome: <br/>
          <a
              href="https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=pt-BR"
              target="_blank"
          >https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=pt-BR
          </a>
        </p>
        <p>
          Safari: <br/>
          <a
              href="https://support.apple.com/pt-br/guide/safari/sfri11471/mac"
              target="_blank"
          >https://support.apple.com/pt-br/guide/safari/sfri11471/mac
          </a>
        </p>
        <p>
          Por fim, lembramos que, caso o Usuário não aceite alguns cookies do Site do
          {{ terms.hashtag }}, certos serviços poderão não funcionar de maneira ideal.
        </p>
        <h3>IV. COM QUEM COMPARTILHAREMOS OS DADOS</h3>
        <p>
          As PARTES constituem grupos econômicos, que trabalham em parceria com diversas
          empresas. Deste modo, poderão compartilhar as informações coletadas por meio
          do Site, nas seguintes hipóteses:
        </p>
        <p>
          ii. Com outras empresas dos seus Grupos Econômicos, constituídas ou atuantes
          em qualquer país, que se comprometem a utilizar as informações para os mesmos
          fins indicados na presente Política;
        </p>
        <p>
          iii. Com empresas parceiras, no desenvolvimento das atividades comerciais e
          campanhas de marketing das PARTES;
        </p>
        <p>
          iv. Para proteção dos interesses das PARTES em qualquer tipo de conflito,
          incluindo ações judiciais;
        </p>
        <p>
          v. No caso de transações e alterações societárias envolvendo as PARTES,
          hipótese em que a transferência das informações será necessária para a
          continuidade dos serviços; ou,
        </p>
        <p>
          vi. Mediante ordem judicial ou pelo requerimento de autoridades
          administrativas que detenham competência legal para sua requisição.
        </p>
        <h3>V. COMO MANTEMOS OS DADOS SEGUROS</h3>
        <p>
          As PARTES armazenarão as informações coletadas em seu Site em servidores
          próprios ou por ela contratados.
        </p>
        <p>
          A <strong>FANBASE</strong> utiliza os meios razoáveis de mercado e legalmente
          requeridos para preservar a privacidade dos dados coletados em seu Site. Desta
          forma, adota as seguintes precauções, em observância às diretrizes sobre
          padrões de segurança estabelecidas no Decreto nº 8.771/2016, tais como:
        </p>
        <p>
          i. A FANBASE utilizam os métodos padrão e de mercado para criptografar e
          anonimizar os dados coletados;
        </p>
        <p>
          ii. A FANBASE possui proteção contra acesso não autorizado a seus sistemas;
        </p>
        <p>
          iii. A FANBASE somente autoriza o acesso de pessoas previamente estabelecidas
          ao local onde são armazenadas as informações coletadas;
        </p>
        <p>
          iv. Aqueles que entrarem em contato com as informações deverão se comprometer
          a manter sigilo absoluto. A quebra do sigilo acarretará responsabilidade civil
          e o responsável será responsabilizado nos moldes da legislação brasileira; e
        </p>
        <p>
          v. Manutenção do inventário indicando momento, duração, identidade do
          funcionário, ou do responsável pelo acesso e o arquivo objeto, com base nos
          registros de conexão e de acesso a aplicações, conforme determinado no artigo
          13 do Decreto nº 8.771/2016.
        </p>
        <p>
          As PARTES adotam os melhores esforços, no sentido de preservar a privacidade
          dos dados dos Usuários. Entretanto, nenhum site é totalmente seguro e as
          PARTES não podem garantir integralmente que todas as informações que trafegam
          no Site não sejam alvo de acessos não autorizados perpetrados por meio de
          métodos desenvolvidos para obter informações de forma indevida. Por esse
          motivo, nós incentivamos os Usuários a tomar as medidas apropriadas para se
          proteger, como, por exemplo, mantendo confidenciais todos os nomes de usuário
          e senhas.
        </p>
        <h3>VI. RETENÇÃO DAS INFORMAÇÕES COLETADAS</h3>
        <p>
          As informações coletadas pela <strong>FANBASE</strong> por meio do Site serão
          automaticamente excluídas de seus servidores quando deixarem de ser úteis para
          os fins para os quais foram coletadas, nos termos de uso do
          <strong>{{ terms.hashtag }}</strong>, ou quando o usuário solicitar a eliminação
          de seus dados pessoais.
        </p>
        <p>
          Sem prejuízo, as informações poderão ser conservadas para cumprimento de
          obrigação legal ou regulatória, transferência a terceiro – desde que
          respeitados os requisitos de tratamento de dados – e uso exclusivo das
          <strong>PARTES</strong>, vedado seu acesso por terceiro, desde que
          anonimizadas.
        </p>
        ]
        <h3>VII. SEUS DIREITOS</h3>
        <p>
          Em cumprimento à regulamentação aplicável, no que diz respeito ao tratamento
          de dados pessoais, as PARTES respeitam e garantem ao Usuário, a possibilidade
          de apresentação de solicitações baseadas nos seguintes direitos:
        </p>
        <p><strong>i)</strong> a confirmação da existência de tratamento;</p>
        <p><strong>ii)</strong>) o acesso aos dados;</p>
        <p>
          <strong>iii)</strong>a correção de dados incompletos, inexatos ou
          desatualizados;
        </p>
        <p>
          <strong>iv)</strong>a anonimização, bloqueio ou eliminação de dados
          desnecessários, excessivos ou tratados em desconformidade;
        </p>
        <p>
          <strong>v)</strong>a portabilidade de seus dados a outro fornecedor de serviço
          ou produto, mediante requisição expressa pelo Usuário;
        </p>
        <p>
          <strong>vi)</strong>a eliminação dos dados tratados com consentimento do
          Usuário;
        </p>
        <p>
          <strong>vii)</strong>a obtenção de informações sobre as entidades públicas ou
          privadas com as quais a PARTES compartilhou seus dados;
        </p>
        <p>
          <strong>viii)</strong>a informação sobre a possibilidade de não fornecer o seu
          consentimento, bem como de ser informado sobre as consequências, em caso de
          negativa;
        </p>
        <p><strong>ix)</strong>a revogação do consentimento.</p>
        <p>
          Parte destes direitos poderá ser exercida diretamente pelo Usuário, a partir
          da gestão de informações sobre sua conta, enquanto outros dependerão do envio
          de solicitação para posterior avaliação e adoção de demais providências pelas
          PARTES.
        </p>
        <p>
          Caso necessite de qualquer auxílio para exercer seus direitos, o Usuário pode
          entrar em contato com as PARTES, conforme orientações nesta Política.
        </p>
        <p>
          O Usuário fica ciente de que a exclusão das informações essenciais para gestão
          de sua conta junto à FANBASE implicará no término de seu cadastro, com
          consequente cancelamento dos serviços então prestados e na participação em
          quaisquer promoções que o Usuário esteja inscrito.
        </p>
        <p>
          A FANBASE empreenderá todos os esforços para atender tais pedidos no menor
          espaço de tempo possível. No entanto, mesmo em caso de requisição de exclusão,
          será respeitado o prazo de armazenamento mínimo de informações de usuários de
          aplicações de Internet, determinado pela legislação brasileira.
        </p>
        <h3>VIII. LEGISLAÇÃO E FORO</h3>
        <p>
          Esta Política será regida, interpretada e executada de acordo com as Leis da
          República Federativa do Brasil, especialmente a Lei nº 13.709/2018,
          independentemente das Leis de outros estados ou Países, sendo competente o
          foro de domicílio do Usuário para dirimir qualquer dúvida decorrente deste
          documento.
        </p>
        <p>
          A FANBASE é a operadora dos dados, sendo que todas as comunicações para o
          encarregado do tratamento dos dados devem ser direcionadas para o e-mail
          <a href="mailto:privacidade@fanbase.com.br.">privacidade@fanbase.com.br.</a>.
        </p>
        <p>Atualizado em 17 de fevereiro de 2024.</p>
      </div>
    </vs-row>
  </div>

</template>

<script>

export default {
  name: 'TermosDefault',
  computed: {
    terms() {
      return this.$store.state.template.terms
    },
    genderuppercase(){
      let gender = this.$store.state.template.nouns;
      if(gender.gender == "1"){
        return 'A'
      }
      else if(gender.gender == "0"){
        return 'O'
      }
    },
    genderlowercase(){
      let gender = this.$store.state.template.nouns;
      if(gender.gender == "1"){
        return 'a'
      }
      else if(gender.gender == "0"){
        return 'o'
      }
    },
    pronoun(){
      let gender = this.$store.state.template.nouns;
      if(gender.gender == "1"){
        return 'da'
      }
      else if(gender.gender == "0"){
        return 'do'
      }
      else{
        return 'do'
      }
    },
    containClientAddress () {
      return (this.terms && this.terms.clientAddress)
    },
    containClientCity () {
      return (this.terms && this.terms.clientCity)
     }
  }
}


</script>

<style scoped>
</style>